import { render } from "./LoaderIndicator.vue?vue&type=template&id=33b378fb&scoped=true"
const script = {}

import "./LoaderIndicator.vue?vue&type=style&index=0&id=33b378fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b378fb"]])

export default __exports__